<div class="card-carousel">
  <sharry-carousel
    [cardTemplate]="cardTemplate"
    [cards]="contents"
    [grid]="grid"
    [gutter]="16"
    [hasShadow]="true"
    [total]="total"
    [trackByProperty]="'id'"
    [usePagination]="usePagination"
    (carouselClick)="carouselClick.emit()"
    (carouselWheel)="carouselWheel.emit()"
    (next)="next.emit()"
    (prev)="prev.emit()">
    <div
      carouselTitle
      class="card-carousel__title">
      <p
        [ngClass]="carouselTitleClass"
        [innerHTML]="carouselTitle | i18next"></p>
      <small [innerHTML]="subtitle | i18next"></small>
    </div>
    <button
      carouselPrev
      mat-mini-fab
      class="mat-icon-button arrow arrow--left arrow--{{ mode }}">
      <sharry-icon
        registryName="caret-left"
        svgClass="svg-icon caret"></sharry-icon>
    </button>
    <button
      carouselNext
      mat-mini-fab
      class="mat-icon-button arrow arrow--right arrow--{{ mode }}">
      <sharry-icon
        registryName="caret-right"
        svgClass="svg-icon caret"></sharry-icon>
    </button>
  </sharry-carousel>
  <ng-template
    #cardTemplate
    let-card>
    @if (mode === 'compact') {
      <sharry-content-card
        [classes]="classes"
        [card]="card"></sharry-content-card>
    }
    @if (mode === 'template' || mode === 'regional-template') {
      <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: card }"></ng-container>
    }
  </ng-template>
</div>
